<ion-header mode="ios">
  <ion-toolbar mode="ios" color="light">
    <ion-title>{{ title }}</ion-title>
    <ion-buttons slot="start">
      <ion-button mode="ios" fill="clear" (click)="dismiss()" tappable>
        <ion-icon color="dark" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  @if (filters?.scopeLabel) {
    <p class="ion-padding-horizontal">Metric scope: {{ filters?.scopeLabel }}</p>
  }
  <ion-list lines="none" mode="ios">
    @if (showDateRange) {
      <h6 class="ion-text-left ion-padding-start">Date Range</h6>
      <ion-radio-group mode="md" [(ngModel)]="preset">
        @for (option of presets; track option.value) {
          <ion-item mode="ios" (click)="onPresetChange(option.value)">
            <ion-label>{{ option.label }}</ion-label>
            <ion-radio slot="start" class="custom-radio" mode="md" [value]="option.value" color="warning"></ion-radio>
          </ion-item>
        }
      </ion-radio-group>

      @if (preset === "custom") {
        <div class="filter-grid">
          <ion-item mode="ios" lines="none">
            <ion-label position="stacked">From</ion-label>
            <ion-input [(ngModel)]="startDate" type="date"></ion-input>
          </ion-item>
          <ion-item mode="ios" lines="none">
            <ion-label position="stacked">To</ion-label>
            <ion-input [(ngModel)]="endDate" type="date"></ion-input>
          </ion-item>
        </div>
      }
    }

    @if (showReportYear) {
      <ion-item mode="ios">
        <ion-input
          label="Report year (UTC)"
          labelPlacement="stacked"
          type="number"
          placeholder="All years"
          [(ngModel)]="reportYear"
        ></ion-input>
      </ion-item>
    }
    @if (statusOptions.length > 0) {
      <h6 class="ion-text-left ion-padding-start">{{ statusLabel }}</h6>
      <ion-radio-group mode="md" [(ngModel)]="status">
        @for (option of statusOptions; track option.value) {
          <ion-item mode="ios" (click)="status = option.value">
            <ion-label>{{ option.label }}</ion-label>
            <ion-radio slot="start" class="custom-radio" mode="md" [value]="option.value" color="warning"></ion-radio>
          </ion-item>
        }
      </ion-radio-group>
    }
    @if (categoryOptions.length > 0) {
      <h6 class="ion-text-left ion-padding-start">Category</h6>
      <ion-radio-group mode="md" [(ngModel)]="category">
        @for (option of categoryOptions; track option.value) {
          <ion-item mode="ios" (click)="category = option.value">
            <ion-label>{{ option.label }}</ion-label>
            <ion-radio slot="start" class="custom-radio" mode="md" [value]="option.value" color="warning"></ion-radio>
          </ion-item>
        }
      </ion-radio-group>
    }
    @if (severityOptions.length > 0) {
      <h6 class="ion-text-left ion-padding-start">Severity</h6>
      <ion-radio-group mode="md" [(ngModel)]="severity">
        @for (option of severityOptions; track option.value) {
          <ion-item mode="ios" (click)="severity = option.value">
            <ion-label>{{ option.label }}</ion-label>
            <ion-radio slot="start" class="custom-radio" mode="md" [value]="option.value" color="warning"></ion-radio>
          </ion-item>
        }
      </ion-radio-group>
    }
    @if (sortOptions.length > 0) {
      <h6 class="ion-text-left ion-padding-start">Sort</h6>
      <ion-radio-group mode="md" [(ngModel)]="sortMode">
        @for (option of sortOptions; track option.value) {
          <ion-item mode="ios" (click)="sortMode = option.value">
            <ion-label>{{ option.label }}</ion-label>
            <ion-radio slot="start" class="custom-radio" mode="md" [value]="option.value" color="warning"></ion-radio>
          </ion-item>
        }
      </ion-radio-group>
    }
    @if (currencyOptions.length > 0) {
      <h6 class="ion-text-left ion-padding-start">Original currency</h6>
      <ion-radio-group mode="md" [(ngModel)]="currency">
        @for (option of currencyOptions; track option.value) {
          <ion-item mode="ios" (click)="currency = option.value">
            <ion-label>{{ option.label }}</ion-label>
            <ion-radio slot="start" class="custom-radio" mode="md" [value]="option.value" color="warning"></ion-radio>
          </ion-item>
        }
      </ion-radio-group>
    }
  </ion-list>
</ion-content>

<ion-footer mode="ios">
  <ion-grid class="ion-no-padding">
    <ion-row>
      <ion-col sizeXl="2.5" sizeLg="2.5" sizeMd="1" sizeSm="0" sizeXs="0"></ion-col>
      <ion-col sizeXl="7" sizeLg="7" sizeMd="10" sizeSm="12" sizeXs="12">
        <ion-row>
          <ion-col size="6">
            <ion-button mode="ios" color="warning" expand="full" shape="round" (click)="apply()">Apply</ion-button>
          </ion-col>
          <ion-col size="6">
            <ion-button mode="ios" color="warning" expand="full" shape="round" (click)="clear()">Clear</ion-button>
          </ion-col>
        </ion-row>
        <br />
      </ion-col>
      <ion-col sizeXl="2.5" sizeLg="2.5" sizeMd="1" sizeSm="0" sizeXs="0"></ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
